import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortDviIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_310"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_310)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.8 7.99913C3.8 7.48363 3.38217 7.06579 2.86667 7.06579C2.35117 7.06579 1.93333 7.48363 1.93333 7.99913C1.93333 8.51463 2.35117 8.93246 2.86667 8.93246C3.38217 8.93246 3.8 8.51463 3.8 7.99913ZM3.33333 7.99913C3.33333 8.25689 3.12443 8.46579 2.86667 8.46579C2.6089 8.46579 2.4 8.25689 2.4 7.99913C2.4 7.74136 2.6089 7.53246 2.86667 7.53246C3.12443 7.53246 3.33333 7.74136 3.33333 7.99913Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2 6.13334V5.43334C12.2 5.17544 11.9912 4.96667 11.7333 4.96667H4.26667C4.00877 4.96667 3.8 5.17544 3.8 5.43334V6.13334H1.7C1.31353 6.13334 1 6.44688 1 6.83334V9.16667C1 9.55314 1.31353 9.86667 1.7 9.86667H3.8V10.5667C3.8 10.8246 4.00877 11.0333 4.26667 11.0333H11.7333C11.9912 11.0333 12.2 10.8246 12.2 10.5667V9.86667H14.3C14.6865 9.86667 15 9.55314 15 9.16667V6.83334C15 6.44688 14.6865 6.13334 14.3 6.13334H12.2ZM11.7333 6.36667C11.7333 6.49554 11.8378 6.60001 11.9667 6.60001H14.3C14.4287 6.60001 14.5333 6.70461 14.5333 6.83334V9.16667C14.5333 9.29541 14.4287 9.40001 14.3 9.40001H11.9667C11.8378 9.40001 11.7333 9.50447 11.7333 9.63334V10.5667H4.26667V9.63334C4.26667 9.50447 4.1622 9.40001 4.03333 9.40001H1.7C1.57127 9.40001 1.46667 9.29541 1.46667 9.16667V6.83334C1.46667 6.70461 1.57127 6.60001 1.7 6.60001H4.03333C4.1622 6.60001 4.26667 6.49554 4.26667 6.36667V5.43334H11.7333V6.36667Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0667 7.99913C14.0667 7.48363 13.6488 7.06579 13.1333 7.06579C12.6178 7.06579 12.2 7.48363 12.2 7.99913C12.2 8.51463 12.6178 8.93246 13.1333 8.93246C13.6488 8.93246 14.0667 8.51463 14.0667 7.99913ZM13.6 7.99913C13.6 8.25689 13.3911 8.46579 13.1333 8.46579C12.8756 8.46579 12.6667 8.25689 12.6667 7.99913C12.6667 7.74136 12.8756 7.53246 13.1333 7.53246C13.3911 7.53246 13.6 7.74136 13.6 7.99913Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.36818 9.16667L5.2 8.66214V6.83334H10.8V8.66214L10.6318 9.16667H5.36818ZM10.8 9.63334C10.9004 9.63334 10.9896 9.56907 11.0214 9.47379L11.2547 8.77379C11.2626 8.75 11.2667 8.72509 11.2667 8.70001V6.83334C11.2667 6.57544 11.0579 6.36667 10.8 6.36667H5.2C4.9421 6.36667 4.73333 6.57544 4.73333 6.83334V8.70001C4.73333 8.72509 4.73738 8.75 4.74531 8.77379L4.97864 9.47379C5.0104 9.56907 5.09957 9.63334 5.2 9.63334H10.8Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.23333 7.53339H8.7V7.06672H8.23333V7.53339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.23333 8.23339H8.7V7.76672H8.23333V8.23339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53333 7.53339H8V7.06672H7.53333V7.53339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53333 8.23339H8V7.76672H7.53333V8.23339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53333 8.93339H8V8.46672H7.53333V8.93339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.23333 8.93339H8.7V8.46672H8.23333V8.93339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93333 7.53339H9.4V7.06672H8.93333V7.53339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.63333 7.53339H10.1V7.06672H9.63333V7.53339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93333 8.23339H9.4V7.76672H8.93333V8.23339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.63333 8.23339H10.1V7.76672H9.63333V8.23339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93333 8.93339H9.4V8.46672H8.93333V8.93339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.63333 8.93339H10.1V8.46672H9.63333V8.93339Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.9 8.23246H7.06667V7.76579H5.9V8.23246Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortDviIcon.displayName = 'PortDviIcon';
